import {
  Box,
  Divider,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";

export const MyAddresses = () => {
  const me = useSelector((state) => state.login.me);

  return (
    <Paper className="p-4">
      <Typography variant="h6" className="mb-4">
        Saved Addresses
      </Typography>
      <Divider sx={{ my: 1 }} />

      <Box className="mt-4">
        {me?.shipping_addresses?.length ? (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>City</TableCell>
                  <TableCell>Address</TableCell>
                  <TableCell>Landmark</TableCell>
                  {/* <TableCell>Action</TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {me?.shipping_addresses?.map((address, i) => (
                  <TableRow key={i}>
                    <TableCell>{address?.name}</TableCell>
                    <TableCell>{address?.city}</TableCell>
                    <TableCell>{address?.address}</TableCell>
                    <TableCell>{address?.landmark}</TableCell>
                    {/* <TableCell className="!flex gap-2 items-center">
                      <MdDelete size={20} color="red" />
                      <EditSharp size={10} />
                    </TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <div className="w-full flex justify-center">No Saved Addresses</div>
        )}
      </Box>
    </Paper>
  );
};
